/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import type { IconViewProps } from '@airasia-phoenix/react-native/components/IconView/index';
import { pd } from '@airasia-phoenix/react-native/tokens';
import PressableView from '@airasia-phoenix/react-native/components/PressableView';
import { AIRASIA_MOVE_LOGO_DATA_URI } from '../../components/airasiaMoveLogo';

const defaultWidth = 148;
const defaultHeight = 33;

export interface ClickableIconProps {
  height?: number;
  width?: number;
  redirectUrl?: string;
  logoIcon?: IconViewProps;
  onPress?: () => void;
}

const ClickableIconView = ({
  height,
  width,
  redirectUrl,
  logoIcon,
  onPress,
}: ClickableIconProps) => {
  const w = width ?? defaultWidth;
  const h = height ?? defaultHeight;

  return (
    <PressableView
      boxShadowBorderRadius={w / 2}
      style={{
        height: h,
        width: w,
        marginRight: pd.ref.space.spacing20.px,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onPress={() => {
        onPress?.();
        if (redirectUrl) window.location.assign(redirectUrl);
      }}
    >
      <img
        alt="Move logo"
        height={h}
        width={w}
        src={logoIcon?.url || logoIcon?.image || AIRASIA_MOVE_LOGO_DATA_URI}
      />
    </PressableView>
  );
};

export default ClickableIconView;
